module.exports = __webpack_public_path__ + "static/media/Advanced-Nuclear.6edaffe9.svg";